// extracted by mini-css-extract-plugin
module.exports = {"toast":"toast_toast__5R9cq","slideInAnimation":"toast_slideInAnimation__xWLDn","error":"toast_error__N64K_"};